<template>
    <div class="result">
        <p v-if="List.lenght">در حال حاضر موردی یافت نگردید.</p>

        <!-- LIST -->
        <div class="table-container" v-else>
            <table class="table table-hover">
                <thead>
                    <tr>
                    <th scope="col">#</th>
                    <th scope="col">عنوان</th>
                    <th scope="col">نوع</th>
                    <th scope="col"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in List" :key="index">
                        <th class="index" scope="row">{{ index + 1}}</th>
                        <td>{{ item.Title }}</td>
                        <td>{{ item.Type == 'Video' ? 'ویدئو' : 'پادکست' }}</td>
                        <td class="options">
                            <router-link tag="span" v-if="item.Type == 'Video'" :to="{ name: 'VideoDetails', params: { id: item._id } }">جزئیات</router-link>
                            <router-link tag="span" v-else :to="{ name: 'PodcastDetails', params: { id: item._id } }">جزئیات</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import { getRequest, APP_API_URL } from '@/utils/libs/api-request';
import Cookies from 'js-cookie';

// import moment from 'moment';

export default {
    name: 'BookMarks',
    data() {
        return {
            URL: APP_API_URL(),

            List: [],
            BookedPodcasts: [],
        }
    },
    mounted() {
        this.GetUser()
    },
    methods: {
        GetUser() {
            if (Cookies.get('access_cookie')) {
                getRequest('/users/user-booked-items')
                    .then(rsp => {
                        // response
                        let data = rsp['data'];

                        data.BookedVideos.forEach(video => {
                            this.List.push({...video, Type: 'Video'})
                        });
                        data.BookedPodcasts.forEach(video => {
                            this.List.push({...video, Type: 'Podcast'})
                        });

                        this.List.sort((a, b) => {
                            let da = new Date(a.Created_at),
                                db = new Date(b.Created_at);
                            return da - db;
                        });
                    })
                    .catch(() => {
                        // error
                    });
            } else {
                this.$router.push({ name: 'Login' })
            }
        },
    }
}
</script>

<style scoped>
/* ---------------------------------------- */
/* ---------------- GENERAL --------------- */
/* ---------------------------------------- */
.result {
    height: calc(100vh - 50pt);

    display: flex;
    flex-direction: column;

    border-bottom-right-radius: 9vh;
    border-bottom-left-radius: 9vh;
    background-color: #ebecf1;
}
.result p {
    margin: 1rem auto;
}

/* --------------------------------- */
/* -------- TABLE CONTAINER -------- */
/* --------------------------------- */
.result table {
    margin-top: 0;
    margin-bottom: 0;
}
.result table td,
.result table th {
    vertical-align: middle;
}
.result .table-container {
    overflow: scroll;
    border: 1pt solid #ccc;
    max-height: calc(100vh - 65pt);
}
.result .table-container .index {
    width: 35pt;
}
.result .table-container .options {
    width: 100pt;
}
.result .table-container .options span {
    font-weight: 500;
}
.result .table-container .options span:hover {
    cursor: pointer;
    text-decoration: underline;
}

</style>